import * as Headless from '@sail/theme-headless';
import {css, theme} from '../theme';

export const Badge = theme(Headless.Badge, [
  css({
    fontSize: css.value('12px'),
    height: css.value('20px'),
    lineHeight: css.value('20px'),
    borderRadius: 'small',
    padding: css.value('0 $space.75'),
    fontWeight: 'semibold',
    borderWidth: css.value('1px'),
    borderStyle: css.value('solid'),
    gap: 50,
    '& > svg': {
      height: css.value('12px'),
      width: css.value('12px'),
    },
    [Headless.BadgeVariants.type.neutral]: {
      color: css.value('$color.neutral600'),
      borderColor: css.value('$color.neutral150'),
      background: css.value('$color.neutral100'),
      '& > svg': {
        color: css.value('$color.neutral500'),
      },
    },
    [Headless.BadgeVariants.type.info]: {
      color: css.value('$color.info600'),
      background: css.value('$color.info100'),
      borderColor: css.value('$color.info150'),
      '& > svg': {
        color: css.value('$color.info500'),
      },
    },
    [Headless.BadgeVariants.type.positive]: {
      color: css.value('$color.success600'),
      background: css.value('$color.success100'),
      borderColor: css.value('$color.success150'),
      '& > svg': {
        color: css.value('$color.success500'),
      },
    },
    [Headless.BadgeVariants.type.negative]: {
      color: css.value('$color.critical600'),
      background: css.value('$color.critical100'),
      borderColor: css.value('$color.critical150'),
      '& > svg': {
        color: css.value('$color.critical500'),
      },
    },
    [Headless.BadgeVariants.type.warning]: {
      color: css.value('$color.attention600'),
      background: css.value('$color.attention100'),
      borderColor: css.value('$color.attention150'),
      '& > svg': {
        color: css.value('$color.attention500'),
      },
    },
    [Headless.BadgeVariants.type.urgent]: {
      color: css.value('$color.neutral0'),
      background: css.value('$color.critical500'),
      borderColor: css.value('$color.critical500'),
      '& > svg': {
        color: css.value('$color.neutral0'),
      },
    },
  }),
]);
